export { default } from './FloatText';